import { Tree } from 'antd';
import renderTreeNode, { RenderTreeNodeArgs } from './renderTreeNode';
import DataNode from '../../../../interfaces/dataRoom/dataNode';
interface TreeNodeInternalProps {
  onSelect;
  onDragEnd;
  expandedKeys;
  checkedKeys;
  onCheck;
  root;
  file;
  folderNodes;
  onNodeClick;
}
export type TreeNodeProps = TreeNodeInternalProps &
  Omit<Omit<RenderTreeNodeArgs, 'onClick'>, 'item'>;
const TreeNode = ({
  onSelect,
  onDragEnd,
  expandedKeys,
  checkedKeys,
  onCheck,
  root,
  file,
  folderNodes,
  onNodeClick,
  isEditable,
  isMobile,
  t,
  onMenuClick,
  onPreview,
  onFileNameChange,
  filesize,
  selectedFolderId,
  propertyId,
}: TreeNodeProps) => (
  <Tree.DirectoryTree
    multiple
    checkable={true}
    selectable={isEditable}
    switcherIcon={<span></span>}
    onSelect={onSelect}
    onDragEnd={onDragEnd}
    expandedKeys={expandedKeys}
    checkedKeys={checkedKeys}
    onCheck={onCheck}
    className="mb-80"
  >
    <Tree.TreeNode
      isLeaf={true}
      checkable={false}
      selectable={false}
      key={root}
      className="data-room__first-node"
      icon={<img src={file} alt="file" className="data-room__icon ml-40" />}
      title={
        <div className="d-flex justify-content-space-between ml-20">
          <span>{t(`f:dataRoom.Name`)}</span>
          {!isMobile && (
            <div className="d-flex align-items-center">
              <div className="data-room__first-node-info-owner">
                {t(`f:dataRoom.owner`)}
              </div>
              <div className="data-room__first-node-info-size">
                {t(`f:dataRoom.size`)}
              </div>
              <div className="data-room__first-node-info-date mr-50">
                {t(`f:dataRoom.createdDate`)}
              </div>
            </div>
          )}
        </div>
      }
    ></Tree.TreeNode>
    {folderNodes.map((item: DataNode) =>
      renderTreeNode({
        item,
        isMobile,
        isEditable,
        onClick: onNodeClick,
        onMenuClick,
        t,
        onFileNameChange,
        onPreview,
        filesize,
        selectedFolderId,
        propertyId,
        checkedKeys,
      })
    )}
  </Tree.DirectoryTree>
);
export default TreeNode;
